module.exports = __webpack_public_path__ + "img/infografica-img-02.00afe5ba.png";